import { GET_NUTRITION_SUMMARY_RESPONSE } from 'actions/baskets';

const initialState = {
  averageCalories: 0,
  averageProtein: 0,
  averageNetCarbs: 0,
  isNutritionSummaryFetched: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_NUTRITION_SUMMARY_RESPONSE:
      return {
        ...state,
        ...action.response.nutritionSummary,
        isNutritionSummaryFetched: true,
      };
    default:
      return state;
  }
};
